import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";

export default function PoliticaPrivacidadePage() {
  return (
    <div className="min-h-screen bg-white relative">
      <Navbar />
      <div className="absolute top-0 left-0 right-0 h-48 md:h-64 bg-gradient-to-b from-alvinegro-black to-white z-0" />
      <main className="pt-20 md:pt-24 pb-12 relative z-10">
        <div className="w-full px-4 md:px-8">
          <Breadcrumb items={[{ label: "Início", path: "/" }, { label: "Política de Privacidade" }]} />
          <div className="max-w-3xl mx-auto">
            <h1 className="font-serif font-bold text-3xl md:text-4xl text-alvinegro-black mb-8">Política de Privacidade</h1>
            <div className="space-y-6">
              <section>
                <h2 className="font-semibold text-lg text-alvinegro-black mb-3">1. Coleta de Informações</h2>
                <p className="text-sm text-alvinegro-dark leading-relaxed">A Central Alvinegra coleta informações pessoais quando você se cadastra, comenta, participa de enquetes ou interage com o site. Essas informações podem incluir nome, e-mail, avatar e preferências de navegação.</p>
              </section>
              <section>
                <h2 className="font-semibold text-lg text-alvinegro-black mb-3">2. Uso das Informações</h2>
                <p className="text-sm text-alvinegro-dark leading-relaxed">Utilizamos suas informações para personalizar sua experiência, enviar newsletters, moderar comentários e melhorar nossos serviços. Não vendemos ou compartilhamos dados com terceiros sem seu consentimento.</p>
              </section>
              <section>
                <h2 className="font-semibold text-lg text-alvinegro-black mb-3">3. Cookies</h2>
                <p className="text-sm text-alvinegro-dark leading-relaxed">Utilizamos cookies para melhorar a navegação, analisar tráfego e personalizar conteúdo. Você pode desabilitar cookies nas configurações do seu navegador.</p>
              </section>
              <section>
                <h2 className="font-semibold text-lg text-alvinegro-black mb-3">4. Segurança</h2>
                <p className="text-sm text-alvinegro-dark leading-relaxed">Adotamos medidas de segurança para proteger seus dados contra acesso não autorizado, alteração ou divulgação. No entanto, nenhum sistema é 100% seguro.</p>
              </section>
              <section>
                <h2 className="font-semibold text-lg text-alvinegro-black mb-3">5. Seus Direitos</h2>
                <p className="text-sm text-alvinegro-dark leading-relaxed">Você tem o direito de acessar, corrigir ou excluir seus dados pessoais. Para solicitações, entre em contato através do e-mail contato@centralalvinegra.com.</p>
              </section>
              <section>
                <h2 className="font-semibold text-lg text-alvinegro-black mb-3">6. Alterações</h2>
                <p className="text-sm text-alvinegro-dark leading-relaxed">Esta política pode ser atualizada periodicamente. Recomendamos revisar esta página regularmente para estar ciente de quaisquer alterações.</p>
              </section>
            </div>
            <p className="text-xs text-alvinegro-muted mt-8">Última atualização: 31 de maio de 2026</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}